angular.module('AuthModule', []);